import { render, staticRenderFns } from "./AvatarDropdown.vue?vue&type=template&id=f6f70ba6&scoped=true&"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js&"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AvatarDropdown.vue?vue&type=style&index=0&id=f6f70ba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f70ba6",
  null
  
)

export default component.exports